import { Checkbox, Col, Form, FormInstance, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const OcularSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasOcular =
    Form.useWatch(['form', 'symptoms', 'ocular', 'status'], form) === 'yes'

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'ocular', 'status']}
          rules={requiredRules}
          label={`4. ${t('epidemiology.ocular')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasOcular && (
        <>
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'ocular',
                'conjunctivitis',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>1. Conjunctivită</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'ocular', 'photophobia', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>2. Fotofobie</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'ocular', 'diplopia', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>3. Diplopie</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'ocular',
                'conjunctivalCongestion',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Congestie conjunctivală</Checkbox>
            </Form.Item>
          </Col>
        </>
      )}
    </>
  )
}
